<template>
  <div id="tab" class="el-container">
    <div class="el-main">
      <el-card shadow="never">
        <div slot="header">
          <span>问题反馈</span>
        </div>
        <el-form :inline="true" class="query_form" size="small">
          <el-form-item label="日期">
            <date-picker v-model="queryForm.billDate.selected" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions"></date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onQuery">查询</el-button>
          </el-form-item>
        </el-form>
      </el-card>
      <div class="table" v-loading="tableLoading">
        <el-table :data="tableData" border stripe size="mini" height="100%" max-height="100%" style="width: 100%" @row-dblclick="handleTableDBClick" @filter-change="filterMethod">
          <el-table-column class-name="index" type="index" width="30"></el-table-column>
          <el-table-column prop="enterpriseName" label="企业名称" width="150">
            <template slot="header" slot-scope="{ column }">
              <el-popover placement="bottom" trigger="click" :ref="`popover_${column.property}`" @show="popoverShow(column.property)">
                <div class="query_btn_group">
                  <el-input v-model="queryForm.enterpriseName.selected" placeholder="输入企业名称搜索" clearable></el-input>
                  <el-button type="text" @click="tableFilter(column.property)">筛选</el-button>
                </div>
                <div slot="reference" :class="['reference', queryForm.enterpriseName.isFilter ? 'highlight' : '' ]"><label>企业名称</label><i class='el-icon-arrow-down'></i></div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="entryUserName" label="提交人" width="150">
            <template slot="header" slot-scope="{ column }">
              <el-popover placement="bottom" trigger="click" :ref="`popover_${column.property}`" @show="popoverShow(column.property)">
                <div class="query_btn_group">
                  <el-input v-model="queryForm.entryUserName.selected" placeholder="输入提交人搜索" clearable></el-input>
                  <el-button type="text" @click="tableFilter(column.property)">筛选</el-button>
                </div>
                <div slot="reference" :class="['reference', queryForm.entryUserName.isFilter ? 'highlight' : '' ]"><label>提交人</label><i class='el-icon-arrow-down'></i></div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="context" label="内容" width="150"></el-table-column>
          <el-table-column prop="picPathArray" label="图片" width="146">
            <template slot-scope="{ row }">
              <el-image style="width: 50px; height: 50px; margin: 6px;" :src="item" fit="fill" v-for="(item, idnex) in row.picPathArray" :key="idnex" lazy :preview-src-list="row.picPathArray"></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="feedType" label="问题类型" width="150" :filters="feedTypeList" column-key="feedType" :filter-multiple="false"></el-table-column>
          <el-table-column prop="phoneModel" label="手机型号" width="150"></el-table-column>
          <el-table-column prop="systemVersion" label="系统型号" width="150"></el-table-column>
          <el-table-column prop="versionCode" label="版本号" width="150"></el-table-column>
          <el-table-column prop="context" label="内容" width="150"></el-table-column>
          <el-table-column prop="entryDateTime" label="提交时间" width="150"></el-table-column>
          <el-table-column prop="mobile" label="联系人" width="100"></el-table-column>
          <el-table-column prop="status" label="状态" width="80" :filters="billStatusList" column-key="billStatus" :filter-multiple="false">
            <template slot-scope="{ row }">
              <el-tag :type="row.status && billStatusList.filter(item => item.value == row.status)[0].type">{{ row.status && billStatusList.filter(item => item.value == row.status)[0].text }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="caozuo" label="操作" width="100" class-name="caozuo" >
            <template slot-scope="scope">
              <div style="width: 100%;display: flex;flex-direction: row; justify-content: center;" v-if="scope.row.status != 'Y'">
                <el-tooltip :hide-after="2000" class="item" effect="dark" content="已处理？点我改变状态" placement="top">
                  <el-button @click="cancelRow(scope)" size="mini">已处理</el-button>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="params.page" :page-sizes="[10, 20, 100]" :page-size="params.size" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
  </div>
</template>

<script>
import datePicker from '@/components/common/datePicker.vue'
import { toRawType, getResultArray, toFixedRe, pickerOptions, getAddDate, getNowFormatDate } from '@/assets/js/common.js'
export default {
  components: {
    datePicker,
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.querySelector("input").onfocus = function (e) {
          e.currentTarget.select();
        };
        el.querySelector("input").focus();
      },
    },
  },
  name: 'SpecialPrice',
  data() {
    return {
      pickerOptions: pickerOptions,
      billStatusList: [
        { value: 'Y', text: '已处理', type: 'success' },
        { value: 'N', text: '未处理', type: 'danger' }
      ],
      feedTypeList: [
        { value: 'A', text: '提交需求', type: 'success' },
        { value: 'B', text: '功能优化', type: 'danger' },
        { value: 'C', text: '问题反馈', type: 'danger' },
      ],
      queryForm: {
        enterpriseName: { submitName: 'enterpriseName', selected: '', isFilter: false },
        entryUserName: { submitName: 'entryUserName', selected: '', isFilter: false },
        billDate: { submitName: 'billDate', selected: [] },
      },
      params: {
        page: 1,
        size: 10,
        beginSearchDate: '',
        endSearchDate: '',
        enterpriseName: '',
        entryUserName: '',
      },
      tableLoading: false,
      tableData: [],
      total: 0
    }
  },
  created() {
    this.getTableList()
  },
  methods: {
    async getTableList() {
      this.tableLoading = true
      const { data: res } = await this.$http.post(
        '/Account/problemFeedback/selectFeedbackList.html',
        this.Qs.stringify(this.params)
      );
      this.tableLoading = false
      if (res.code != '0') return this.$message.error(res.message)
      let { data, total } = JSON.parse(res.data)
      this.total = total
      this.tableData = JSON.parse(data)
    },
    onQuery() {
      this.params.page = 1
      Object.values(this.queryForm).forEach(item => {
        if (item.submitName == 'billDate') {
          console.log(item)
          this.params['beginSearchDate'] = item.selected ? (item.selected[0] || '') : ''
          this.params['endSearchDate'] = item.selected ? (item.selected[1] || '') : ''
          return false
        } else if (toRawType(item.selected) == 'Array') {
          this.params[item.submitName] = item.selected.map(i => "'" + i.value + "'").join(',') || ''
        } else if (toRawType(item.selected) == 'Object') {
            // if (['salOrderMeet', 'customer', 'brand', 'salesman'].includes(item.submitName)) {
            //   this.params[item.submitName + 'ID'] = item.selected.value || ''
            //   this.params[item.submitName + 'Name'] = item.selected.text || ''
            //   return false
            // }
            this.params[item.submitName] = item.selected.value || ''
        } else {
          if (item.selected) this.params[item.submitName] = item.selected
        }
      })
      this.getTableList()
    },
    handleSizeChange(newSize) {
      this.params.size = newSize
      this.getTableList()
    },
    // 翻页
    handleCurrentChange(newPage) {
      this.params.page = newPage
      this.getTableList()
    },
    // 筛选框打开时触发事件
    popoverShow (tag) {
      const popover = this.$refs['popover_' + tag]
      popover.$nextTick(() => {
        popover.$children[0].focus()
      })
    },
    // 其他自定义筛选
    tableFilter (tag) {
      this.$refs['popover_' + tag].doClose()
      let item = this.queryForm[tag]
      if (Array.isArray(item.selected)) {
        this.params[tag] = item.selected.map(element => ("'" + element.value + "'")).join(',')
        item.isFilter = item.selected.length ? true : false
      } else {
        this.params[tag] = item.selected
        item.isFilter = item.selected ? true : false
      }
      this.params.keyWords = this.params.planDesc
      this.params.page = 1
      this.getTableList()
    },
    // 系统筛选
    filterMethod ({ billStatus, feedType }) {
      if (billStatus) {
        this.params.status = billStatus[0] || ''
      }
      if (feedType) {
        this.params.feedType = feedType[0] || ''
      }
      this.params.page = 1
      this.getTableList()
    },
    handleTableDBClick({ planID }) {
      
    },
    async cancelRow({ row }) {
      const confirmResult = await this.$confirm('点击后状态变更为已处理，且不能再变更, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)
      if (confirmResult !== 'confirm') return this.$message.info('取消' + tips)
      const loading = this.$loading({
        lock: true,
        text: '变更中，请耐心等待',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const { data: res } = await this.$http.post(
        '/Account/problemFeedback/updateFeedbackStatus.html',
        this.Qs.stringify({
          id: row.id,
        })
      );
      loading.close()
      if (res.code != '0') return this.$confirm(res.message, '提示', {
        confirmButtonText: '确定',
        showCancelButton: false,
        type: 'warning'
      })
      this.$message.success('变更成功')
      this.getTableList()
    },
  }
}
</script>

<style scoped lang="less">
.query_btn_group {
  display: flex;
}

.query_btn_group .el-button {
  margin-left: 6px;
  color: #606266;
}

.query_btn_group .el-button:hover {
  color: #409EFF;
}

.reference {
  cursor: pointer;
}
.reference.highlight label {
  color: #409EFF;
}
::v-deep .select_multiple .el-select__tags {
  /*display: block;*/
  max-height: 32px;
  overflow: auto;
}
.el-main {
  padding: 0;
  display: flex;
  flex-direction: column;
  flex: 1;
  flex-basis: auto;
  box-sizing: border-box;
  min-width: 0;
  .table {
    display: block;
    flex: 1;
    flex-basis: auto;
    box-sizing: border-box;
    overflow: auto;
    ::v-deep .el-table {
      .index {
        div {
          padding: 0;
          text-align: center;
        }
      }
      // .caozuo {
      //   .el-button {
      //     font-size: 16px;
      //     & + .el-button {
      //       margin-left: 4px;
      //     }
      //   }
      // }
      .el-table__cell {
        padding: 0;
      }
    }
  }
  .el-pagination {
    box-sizing: border-box;
    flex-shrink: 0;
  }
}
::v-deep .dialog {
  .main {
    height: 70vh;
    .el-card {
      .el-card__body {
        display: flex;
        & > div:nth-child(1) {
          margin-right: 10px;
          .el-form {
            .el-form-item {
              width: 100%;
              .el-form-item__content {
                width: 100%;
              }
            }
          }
        }
        & > div:nth-child(2) {
          width: 300px;
          flex-shrink: 0;
        }
        .el-form {
          height: auto;
        }
      }
    }
    .dialogTable {
      display: flex;
    }
    .el-radio-group {
      display: flex;
      flex-flow: column;
      margin-top: 12px;
      .el-radio + .el-radio {
        margin-top: 6px;
      }
    }
    .customerType {
      height: 100%;
      .el-scrollbar {
        height: 100%;
        width: 100%;
        li {
          text-align: center;
          list-style: none;
        }
      }
    }
    .el-input-number {
      input {
        padding: 0;
        text-align: left;
      }
    }
  }
}
::v-deep .dialogDomain {
  .el-card.cardDomain {
    height: 50vh;
    .el-card__body {
      height: 100%;
      padding: 0;
    }
  }
}
::v-deep .dialogCustomer {
  height: 90vh;
  display: flex;
  flex-direction: column;
  flex: 1;
  flex-basis: auto;
  box-sizing: border-box;
  min-width: 0;
  .el-dialog__header,
  .el-card__header {
    box-sizing: border-box;
    flex-shrink: 0;
  }
  .el-dialog__body {
    flex: 1;
    flex-basis: auto;
    box-sizing: border-box;
    overflow: auto;
  }
}
::v-deep .dialog,
::v-deep .dialogDomain {
  .el-dialog__footer{
    text-align: center;
  }
}
::v-deep .el-card {
  box-sizing: border-box;
  flex-shrink: 0;
  .el-card__header {
    padding: 8px 20px;
    height: 33px;
    background-color: #F5F7FA;
    color: #409EFF;
    font-size: 14px;
  }

  .el-card__body {
      padding: 12px;
      .query_form {
        .el-form-item {
          position: relative;
          .el-form-item__label {
            position: absolute;
            z-index: 2;
            top: -12px;
            margin-left: 10px;
            padding: 0 6px;
            line-height: normal;
            background-color: #fff;
            color: #000;
          }
        }
      }
      .el-form {
          display: flex;
          height: 100%;
          & + .el-form {
            margin-top: 12px;
          }
          .el-scrollbar {
              height: 100%;
          }

          .el-form-item {
              margin: 0;
              & + .el-form-item {
                margin-left: 10px;
              }
              .amt-info {
                  border: 1px #F56C6C solid;
                  color: #F56C6C;

                  span {
                      display: block;
                      text-align: center;
                  }
              }
          }
      }

      .calculation-form {
          .el-form-item {
              text-align: center;

              .el-form-item__label {
                  margin: 0;
                  left: 36px;
              }

              .input-with-select {
                  .el-input-group__prepend {
                      padding: 0 12px;
                      background-color: #fff;

                      .select-multiple {
                          display: inline-block;
                          width: 50px;
                      }
                  }
              }

              .el-input-number .el-input__inner {
                  text-align: left;
              }
          }
      }
  }
}
</style>